import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a3098e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "st_contact p-0",
  id: "contactUsHome"
}
const _hoisted_2 = { class: "container wrapper" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-7 white_bg\" data-v-20a3098e><div class=\"contact_us_box\" data-v-20a3098e><h2 class=\"title\" data-title=\"contact us\" data-v-20a3098e>contact us</h2><h3 class=\"sub_title\" data-v-20a3098e> Have a question? <br data-v-20a3098e> Send us a message and we <br data-v-20a3098e> will be in touch. </h3><div class=\"contact_details_wrap\" data-v-20a3098e><p data-v-20a3098e><b data-v-20a3098e>CONTACT DETAILS</b></p><ul data-v-20a3098e><li class=\"icon call\" data-v-20a3098e><a href=\"tel:0860522322\" target=\"_blank\" data-v-20a3098e>0860 522 322</a></li><li class=\"icon email\" data-v-20a3098e><a href=\"mailto:telesales@stamford.co.za\" data-v-20a3098e>telesales@stamford.co.za</a></li></ul></div><div class=\"add_details_wrap\" data-v-20a3098e><ul data-v-20a3098e><li class=\"icon add\" data-v-20a3098e><b class=\"d-block text-upppercase\" data-v-20a3098e>CAPE TOWN </b> Office 203A, Pine Park, 1 Logan Way, Pinelands, 7405 </li><li class=\"icon add\" data-v-20a3098e><b class=\"d-block text-upppercase\" data-v-20a3098e>JOHANNESBURG</b> 4 Brine Avenue, Chloorkop, Extension 1, Johannesburg, 1624 </li><li class=\"icon add\" data-v-20a3098e><b class=\"d-block text-upppercase\" data-v-20a3098e>DURBAN</b> 7 Stanhope Pl, Briardene, Durban, 4051 </li></ul></div></div></div>", 1)
const _hoisted_5 = { class: "col-lg-5 grey_light_bg" }
const _hoisted_6 = { class: "form_wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title",
  "data-title": "ENQUIRE"
}, "ENQUIRE", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, "Name:", -1))
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, "Phone:", -1))
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, "email:", -1))
const _hoisted_16 = { class: "invalid-feedback" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, "Subject:", -1))
const _hoisted_19 = {
  key: 0,
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "invalid-feedback" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, "Message:", -1))
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "col-12 mt-3"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Email sent successfully! Thank you.", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "col-12 mt-3"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createTextVNode("Error sending form. Please "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:telesales@stamford.co.za",
    class: "text-decoration-none"
  }, "contact us via email"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx, _cache) {
  const _component_Field = _resolveComponent("Field")
  const _component_Spinner = _resolveComponent("Spinner")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Form, {
              onSubmit: _ctx.onSubmit,
              "validation-schema": _ctx.schema,
              onInvalidSubmit: _cache[5] || (_cache[5] = $event => {_ctx.formSubmission=false;_ctx.sendError=false;})
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_Field, {
                    disabled: _ctx.loading,
                    type: "text",
                    name: "name",
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.name) = $event)),
                    class: _normalizeClass([{ 'is-invalid': errors.name }, "form-control"])
                  }, null, 8, ["disabled", "modelValue", "class"]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(errors.name), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    disabled: _ctx.loading,
                    type: "text",
                    name: "phone",
                    modelValue: _ctx.form.phone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.phone) = $event)),
                    class: _normalizeClass([{ 'is-invalid': errors.phone }, "form-control"])
                  }, null, 8, ["disabled", "modelValue", "class"]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(errors.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_Field, {
                    disabled: _ctx.loading,
                    type: "email",
                    name: "email",
                    modelValue: _ctx.form.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.form.email) = $event)),
                    class: _normalizeClass([{ 'is-invalid': errors.email }, "form-control"])
                  }, null, 8, ["disabled", "modelValue", "class"]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(errors.email), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Field, {
                    disabled: _ctx.loading,
                    as: "select",
                    name: "subject",
                    modelValue: _ctx.form.subject,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.form.subject) = $event)),
                    class: _normalizeClass([{ 'is-invalid': errors.subject }, "form-control form-select"]),
                    id: "disabledSelect"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.form.subject)
                        ? (_openBlock(), _createElementBlock("option", _hoisted_19, "Choose..."))
                        : _createCommentVNode("", true),
                      _createElementVNode("option", { value: _ctx.dealerFormKey }, "Become a dealer", 8, _hoisted_20),
                      _createElementVNode("option", { value: _ctx.enquiryFormKey }, "Send an enquiry", 8, _hoisted_21)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "modelValue", "class"]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(errors.subject), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_Field, {
                    disabled: _ctx.loading,
                    as: "textarea",
                    name: "message",
                    modelValue: _ctx.form.message,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.form.message) = $event)),
                    class: _normalizeClass([{ 'is-invalid': errors.message }, "form-control"])
                  }, null, 8, ["disabled", "modelValue", "class"]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(errors.message), 1)
                ]),
                _createElementVNode("button", {
                  disabled: _ctx.loading,
                  type: "submit",
                  class: "btn blue_btn",
                  style: {"height":"60px"}
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "SUBMIT ENQUIRY"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, [
                        _createVNode(_component_Spinner, { visible: _ctx.loading }, null, 8, ["visible"])
                      ]))
                ], 8, _hoisted_26),
                (_ctx.formSubmission)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                  : (_ctx.sendError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ])
    ])
  ]))
}